module.exports = __webpack_public_path__ + "img/S1.e8c636a6.png";